/**
 * Single-select "Insight assignment" filter value. Empty string means no selection.
 * Each value maps to a combination of the `insight` cube boolean flags in
 * `buildInsightAssignmentFilter`.
 */
export type InsightAssignment = '' | 'hcp' | 'hco' | 'unassigned';

export const INSIGHT_ASSIGNMENT_VALUES: readonly InsightAssignment[] = ['hcp', 'hco', 'unassigned'];

/** Narrows any raw value (stored JSON, form value) to a known assignment, defaulting to ''. */
export const coerceInsightAssignment = (value: unknown): InsightAssignment =>
  INSIGHT_ASSIGNMENT_VALUES.find(assignment => assignment === value) ?? '';

export type InsightFilters = {
  indication: string[];
  product: string[];
  tag: string[];
  fieldForceCode: string[];
  employeeType: string[];
  employeeName: string[];
  insightAssignment: InsightAssignment;
  notLinkedToProduct: boolean;
};

export const DEFAULT_INSIGHT_FILTERS: InsightFilters = {
  indication: [],
  product: [],
  tag: [],
  fieldForceCode: [],
  employeeType: [],
  employeeName: [],
  insightAssignment: '',
  notLinkedToProduct: false,
};

export type InsightsFilterName = {
  [K in keyof InsightFilters]: InsightFilters[K] extends string[] ? K : never;
}[keyof InsightFilters];
